<template>
    <div v-if="type=='gray'" class="center overflow-hidden p-0 mb-3">
		<div class="flex w-full h-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5 md:pt-3 md:pb-5">
			<div class="flex flex-column w-full h-full 
                xl:border-round-xl lg:border-round-xl md:border-round-lg"
                :class="(nopadding) ? 'p-0' : 'py-4 px-3 xl:p-6 lg:p-5 md:p-4'"> 
                <span v-if="header" class="text-900 font-medium mb-3 xl:mb-4 
                    text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                    flex xl:flex lg:flex md:flex"
                    :class="(header_pos=='center') ? 'justify-content-center text-center' : 'justify-content-start text-left'">
                    {{ header }}
                </span>
                <!--Page body start-->
                <slot name="body"></slot>
                <!--Page body end-->
			</div>
		</div>
	</div>

    <div v-else class="center w-full h-full overflow-hidden
        p-0 pb-0 xl:px-5 xl:pb-5 lg:px-3 lg:pb-3 md:px-2 md:pb-2">
		<div class="flex w-full h-full justify-content-center align-items-center">
			<div class="flex flex-column w-full h-full surface-0 p-3 border-1 border-200 shadow-01
                xl:p-6 lg:p-5 md:p-4 
                xl:border-round-3xl lg:border-round-2xl md:border-round-xl">
                <span v-if="header" class="text-900 font-medium mb-3 xl:mb-4 
                    text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                    flex xl:flex lg:flex md:flex"
                    :class="(header_pos=='center') ? 'justify-content-center' : 'justify-content-start'">
                    {{ header }}
                </span>
                <!--Page body start-->
                <slot name="body"></slot>
                <!--Page body end-->
			</div>
		</div>
	</div>
</template>

<script>
export default {
    props: ['header', 'type', 'nopadding', 'header_pos'],
    data() {
        return {
            
        }
    }
}
</script>
